import type { ContactPointDTO, FoundingRoomDTO, NewFoundingDTO } from '@ui/shared/util-api';
import {
    type FoundingMapItem,
    FoundingMapItemModel,
} from '../entities/founding-map-item.model';
import { NewFoundingMapItemModel } from '../entities/new-founding-map-item.model';

export class FoundingMapItemMapper {
    public static fromContactPointDto(item: ContactPointDTO): FoundingMapItemModel {
        return new FoundingMapItemModel({
            ...this._fromDto(item),
            tags: ['Anlaufstelle'],
            uniqueId: `${ item.id }-contact-point`,
            description: item.description,
            targetGroups: item.target_groups.map(group => group.name),
            contact: {
                id: item.contact.id,
                firstName: item.contact.first_name,
                lastName: item.contact.last_name,
                phone: item.contact.phone ?? undefined,
                email: item.contact.email ?? undefined,
            },
        });
    }

    public static fromRoomDto(item: ContactPointDTO): FoundingMapItemModel {
        return new FoundingMapItemModel({
            ...this._fromDto(item),
            tags: ['Workspace'],
            uniqueId: `${ item.id }-room`,
            description: item.description,
            targetGroups: item.target_groups.map(group => group.name),
        });
    }

    public static fromNewFoundingDto(item: NewFoundingDTO): FoundingMapItemModel {
        return new NewFoundingMapItemModel({
            ...this._fromDto(item),
            uniqueId: `${ item.id }-new-founding`,
            tags: ['Neugründung'],
            foundingYear: item.founding_year,
            foundingCategories: item.founding_categories.map(category => category.name),
            ideaDescription: item.idea_description,
        });
    }

    protected static _fromDto(item: ContactPointDTO | FoundingRoomDTO | NewFoundingDTO): FoundingMapItem {
        return {
            id: item.id,
            iconPath: item.icon ?? '',
            imagePath: item.image.image,
            thumbnailPath: item.image.thumbs?.preview ?? item.image.thumbs?.detail ?? '',
            uniqueId: `${ item.id }`,
            title: item.title,
            location: item.location,
            short_description: item.short_description,
            tags: [],

            addressAddition: item.address_addition ?? undefined,
            email: item.email,
            fax: item.fax ?? undefined,
            website: item.website,
        };
    }
}
